;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.3";import {
  configureReplayTreeShakingGlobals,
  sentryInit,
} from '@anchorage/sentry';

// Sentry's client init lives here: @sentry/nextjs discovers
// sentry.client.config.ts only on its webpack path, and every app builds with
// Turbopack. The replay globals must be set before init constructs replay.
configureReplayTreeShakingGlobals();

// Feedback integration off to save ~30-50KB (gzipped) from the bundle.
sentryInit({ enableFeedback: false });
